import styled, { css } from 'styled-components';

export const StyledReadMoreLink = styled.span`
  font-family: 'Archivo', sans-serif;
  color: ${({ theme }) => theme.text};
  font-size: 12px;
  cursor: pointer;
  ${({ additionalLabelStyles }) => {
    if (additionalLabelStyles) {
      return css`
        ${additionalLabelStyles}
      `;
    }
  }}
`;
